import React, { useEffect, useState } from 'react';
import { Drawer } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/shared-components/Flex';
import { faClipboardList, faPhone, faReply, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { CloseOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { useMyContext } from 'Context/MyContextProvider';
import { renderBody } from '../Utils/utils';
import chatBackground from  '../../../../assets/image/chat-bg.png';
const NewMobilePreview = ({ requestType, template, newMesaage, customMessage, mediaLink,mediaRequired=true }) => {
  const { getMedia, getUrlFromMediaId } = useMyContext()
  // mobile preview style 
  const styles = {

    chatBackground: {
      backgroundImage: `url(${chatBackground})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      borderRadius: '8px',
      padding: '16px',
      minHeight: '200px',
    },
    chatBubble: {
      background: 'white',
      borderRadius: '8px',
      padding: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      position: 'relative',
      marginLeft: '20px',
      maxWidth: '85%',
      wordWrap: 'break-word',
    },
    buttoneBubble: {
      background: 'white',
      borderRadius: '8px',
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,

      // padding: '16px',
      boxShadow: '0 8px 8px -4px rgba(0, 0, 0, 0.15)',
      position: 'relative',
      bottom: '0.5rem',
      marginLeft: '20px',
      maxWidth: '85%',
      wordWrap: 'break-word',
    },
    chatBubbleBefore: {
      content: '""',
      position: 'absolute',
      top: '0',
      left: '-5px',
      width: '0',
      height: '0',
      borderStyle: 'solid',
      borderWidth: '10px 10px 10px 0',
      borderColor: 'transparent white transparent transparent',
      background: '#ffff',
      backgroundColor: '#ffff',
      clipPath: 'polygon(0 0, 0 100%, 100% 100%)',
      transform: 'rotate(180deg)',
    },
    chatTime: {
      textAlign: 'right',
      fontSize: '12px',
      color: 'gray',
      marginTop: '8px',
    },
    footerMessageStyle: {
      fontSize: '12px',
      marginTop: '5px',
      color: '#918f8f'
    },
    buttonStyle: {
      // fontSize: '11px',
      wordWrap: 'break-word',
      fontFamily: 'system-ui',
      display: 'block',
      fontWeight: '600',
      color: '#00a5f4',
      textDecoration: 'none',
      textAlign: 'justify',
    }
  };

  const [displayText, setDisplayText] = useState('');
  const [currentTime, setCurrentTime] = useState('');
  const [isHovered, setIsHovered] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [media, setMedia] = useState([]);

  useEffect(() => {
    setDisplayText(newMesaage ? newMesaage : template?.body?.text);
  }, [newMesaage, template]);


  useEffect(() => {
    mediaRequired && getMedia(setMedia)
    const updateCurrentTime = () => {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      setCurrentTime(`${hours}:${minutes}`);
    };

    updateCurrentTime();
    const interval = setInterval(updateCurrentTime, 60000);

    return () => clearInterval(interval);
  }, []);

  const buttonConfig = {
    QUICK_REPLY: {
      icon: faReply,
      element: 'button',
      props: {
        className: "border-0 bg-transparent w-100",
      }
    },
    FLOW: {
      icon: faClipboardList,
      element: 'button',
      props: {
        className: "border-0 bg-transparent w-100",
      }
    },
    URL: {
      icon: faUpRightFromSquare,
      element: 'a',
      props: (item) => ({
        href: item.url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "border-0 bg-transparent w-100 d-block text-center",
      })
    },
    PHONE_NUMBER: {
      icon: faPhone,
      element: 'a',
      props: (item) => ({
        href: `tel:${item.phone_number}`,
        className: "border-0 bg-transparent w-100 d-block text-center",
      })
    }
  };

  const renderButton = (item, gap = '5px') => {
    const config = buttonConfig[item.type];
    if (!config) return null;

    const Element = config.element;
    const props = typeof config.props === 'function' ? config.props(item) : config.props;

    return (
      <Element {...props}>
        <span style={styles.buttonStyle}>
          <Flex justifyContent='center' alignItems='center' gap={gap}>
            <FontAwesomeIcon icon={config.icon} />
            <span>{item.text}</span>
          </Flex>
        </span>
      </Element>
    );
  };

  useEffect(() => {
    if (drawerVisible) {
      const sharedStyles = {
        borderBottomLeftRadius: '1rem',
        borderBottomRightRadius: '1rem',
        boxShadow: 'none',
        overflow: 'hidden'
      };

      const elements = [
        '.ant-drawer-content',
        '.ant-drawer-content-wrapper'
      ];

      elements.forEach(selector => {
        const element = document.querySelector(selector);
        if (element) {
          Object.assign(element.style, sharedStyles);
        }
      });
    }
  }, [drawerVisible]);
  return (
    <div style={{ overflow: 'auto' }}>
      <div style={styles.chatBackground}>
        <div style={styles.chatBubble}>
          <div style={styles.chatBubbleBefore}></div>
          {requestType === 'template' ? (
            <>
              {/* //header */}
              <div className="header">
                {
                  template?.header?.format === 'DOCUMENT' ?
                    <div className='border rounded d-flex justify-content-center align-items-center mb-3' style={{ background: '#ccd0d5', width: '100%' }}>
                      <img
                        src={'/img/pdfBackground.png'}
                        className='my-3'
                        width={70}
                        alt='pdf'
                      />
                    </div>
                    :
                  template?.header?.format === 'LOCATION' ?
                    <div className='mb-3' style={{ width: '100%', borderRadius: '8px', overflow: 'hidden' }}>
                      <img
                        src={'/img/location.png'}
                        style={{ width: '100%', height: '140px', objectFit: 'cover', display: 'block' }}
                        alt='location'
                      />
                    </div>
                    :
                    template?.header?.format === 'IMAGE' ?
                      <div className='mb-2' style={{ borderRadius: '8px', overflow: 'hidden', margin: '-8px -8px 8px -8px', width: 'calc(100% + 16px)' }}>
                        <img
                          src={mediaLink ? getUrlFromMediaId(mediaLink, media) : '/img/others/dummy-header.jpg'}
                          style={{ width: '100%', height: '180px', objectFit: 'cover', display: 'block' }}
                          alt='header'
                        />
                      </div>
                      :
                      template?.header && template?.header?.format === 'VIDEO' ?
                        <div className='mb-3' style={{ width: '100%', borderRadius: '8px', overflow: 'hidden' }}>
                          <img src={'/img/dummyvideo.png'} className='mt-1 border rounded' alt='video' width={'100%'} />
                        </div>
                        :
                        <div className='header'>
                          <h5> {renderBody(template?.header?.text)}</h5>
                        </div>
                }
              </div>
              {/* body */}
              <div className="body">
                {displayText && (
                  <div className='mt-1'>
                    {renderBody(displayText)}
                  </div>
                )}
              </div>
              {/* footer */}
              <div className="footer">
                <span style={styles.footerMessageStyle}>
                  {template?.footer?.text ? template.footer.text : null}
                </span>
              </div>
            </>
          ) : (
            // custom message
            <div className="custom-message">
              {renderBody(customMessage)}
            </div>
          )}
          {/* time */}
          <div className="time">
            <div style={styles.chatTime}>{currentTime}</div>
          </div>
        </div>
        {/* button  */}
        {template?.buttons?.buttons?.length > 0 && (
          <>
            <div className='buttons' style={styles.buttoneBubble}>
              {(() => {
                const allButtons = template.buttons.buttons;
                const shouldShowDrawer = allButtons.length > 3;
                const visibleButtons = shouldShowDrawer ? allButtons.slice(0, 2) : allButtons;
                return (
                  <>
                    {visibleButtons.map((item, index) => (
                      <span style={styles.buttonStyle} className="border-top py-2" key={index}>
                        {renderButton(item)}
                      </span>
                    ))}

                    {shouldShowDrawer && (
                      <span style={styles.buttonStyle} className="border-top py-2">
                        <button
                          className="border-0 bg-transparent w-100 cursor-pointer"
                          style={styles.buttonStyle}
                          onClick={() => setDrawerVisible(true)}
                        >
                          <Flex justifyContent="center" alignItems="center" gap="5px">
                            <UnorderedListOutlined />
                            <span>Show More</span>
                          </Flex>
                        </button>
                      </span>
                    )}
                  </>
                );
              })()}
            </div>

            <Drawer
              title="Choose an option"
              placement="bottom"
              onClose={() => setDrawerVisible(false)}
              open={drawerVisible}
              height="auto"
              styles={{ body: { padding: '0', position: "absolute" } }}
              rootStyle={{ position: "absolute" }}
              getContainer={false}
              closeIcon={<CloseOutlined />}
              mask={false}
            >
              <div style={{ backgroundColor: '#f5f5f5' }}>
                {template.buttons.buttons.map((item, index) => {
                  const config = buttonConfig[item.type];
                  if (!config) return null;

                  const Element = config.element;
                  const baseProps = typeof config.props === 'function' ? config.props(item) : config.props;
                  const drawerProps = {
                    ...baseProps,
                    className: baseProps.className?.replace('w-100', '') + ' border-0 bg-transparent d-block text-center',
                    style: { ...baseProps.style, padding: '16px 0', width: '100%' },
                    onClick: () => setDrawerVisible(false)
                  };

                  return (
                    <div
                      key={index}
                      style={{
                        backgroundColor: 'white',
                        borderBottom: index === template.buttons.buttons.length - 1 ? 'none' : '1px solid #f0f0f0',
                        padding: '0 16px'
                      }}
                    >
                      <Element {...drawerProps}>
                        <span style={styles.buttonStyle}>
                          <Flex justifyContent='center' alignItems='center' gap={10}>
                            <FontAwesomeIcon icon={config.icon} />
                            <span>{item.text}</span>
                          </Flex>
                        </span>
                      </Element>
                    </div>
                  );
                })}
              </div>
            </Drawer>
          </>
        )}

      </div>
    </div>
  )
}

export default NewMobilePreview
